import { Container } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import AppVersionsList from '../../../Component/Application/AppVersions/AppVersionsList';
import { useTranslation } from 'react-i18next';

const AppVersionsManagement = () => {
  const { t } = useTranslation();
  return (
    <div className="page-body">
      <Breadcrumbs mainTitle={t('Gestión de Versiones APK')} parent={t('Administración')} />
      <Container fluid>
        <AppVersionsList />
      </Container>
    </div>
  );
};

export default AppVersionsManagement;

